// extracted by mini-css-extract-plugin
export default {"wrapper":"Message_wrapper__ftycN","logoBlock":"Message_logoBlock__SL1BP","logo":"Message_logo__tWSDB","photoBlock":"Message_photoBlock__ohj8U"};